import React from 'react';
import {
  Box, Card, Grid, Stack, TextField,
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import { Controller, useFormContext } from 'react-hook-form';
import { BecomePartnerValues } from '../../../types';

const CONFIG = [
  { name: 'contactPersonName', label: 'Name' },
  { name: 'companyName', label: 'Company' },
  { name: 'country', label: 'Country' },
  { name: 'city', label: 'City' },
  { name: 'phoneNumber', label: 'Phone Number' },
  { name: 'email', label: 'Email' },
  { name: 'websiteUrl', label: 'Website' },
];

// eslint-disable-next-line max-len
export const BecomePartnerForm: React.FC<{ onAction: (values: BecomePartnerValues) => Promise<void> }> = ({ onAction }) => {
  const {
    control, handleSubmit, formState: { isSubmitting },
  } = useFormContext();

  return (
    <form onSubmit={handleSubmit(onAction)}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Card sx={{ p: 3 }}>
            <Stack spacing={3}>
              {CONFIG.map(({ name, label }) => (
                <Controller
                  key={name}
                  name={name as keyof BecomePartnerValues}
                  control={control}
                  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      fullWidth
                      label={label}
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                />
              ))}
            </Stack>
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
              <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                Save Changes
              </LoadingButton>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </form>
  );
};
